import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, Redirect, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { completeChapter, completeCourse } from '../redux/actions';
import { selectChapterLessons, selectLesson, selectChapter, selectCourse, selectCourses } from '../redux/selectors';
import Icon from '../../../common/icons/Icon';
import DailyExtra from '../components/DailyExtra';

import { FacebookShareButton, TwitterShareButton } from 'react-share';

class LessonComplete extends Component {
  static propTypes = {
    lessons: PropTypes.array.isRequired,
    lesson: PropTypes.object.isRequired,
    chapter: PropTypes.object.isRequired,
    course: PropTypes.object.isRequired,
    courses: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { course, lessons, lesson, chapter, dispatch } = this.props;

    const chapterIndex = course.chapters.findIndex(c => c.id === chapter.id);
    const lessonIndex = lessons.findIndex(l => l.id === lesson.id);
    const chapterComplete = lessons.length === lessonIndex + 1;
    const courseComplete = chapterComplete && course.chapters.length === chapterIndex + 1;

    if (!chapter.complete && chapterComplete) {
      dispatch(completeChapter(chapter.id)).then(() => {
        if (!course.complete && courseComplete) {
          dispatch(completeCourse(course.id));
        }
      });
    }
  }

  handleNextChapter = () => {
    const { chapter, course, history } = this.props;

    const chapterIndex = course.chapters.findIndex(c => c.id === chapter.id);
    const chapterId = course.chapters[chapterIndex + 1].id;

    history.push(`/subscription/courses/${course.id}/chapters/${chapterId}`);
  };

  renderSocialLinks = () => {
    return (
      <div className="lesson-complete__social-links">
        <FacebookShareButton
          url="http://app.tathatagolf.com/trial"
          quote="I just completed a Lesson on Tathata Golf - Get your free 7 Day Trial"
          hashtag="#tathatagolf"
        >
          <Icon icon="Facebook" />
        </FacebookShareButton>
        <TwitterShareButton
          url="http://app.tathatagolf.com/trial"
          quote="I just completed a Lesson on Tathata Golf - Get your free 7 Day Trial"
          hashtags={['#tathatagolf']}
        >
          <Icon icon="Twitter" />
        </TwitterShareButton>
        {/* <a href="https://www.facebook.com/tathatagolf" target="_blank" rel="noopener noreferrer">
          <Icon icon="Facebook" />
        </a>
        <a href="https://www.twitter.com/tathatagolf" target="_blank" rel="noopener noreferrer">
          <Icon icon="Twitter" />
        </a>
        <a href="https://www.instagram.com/tathatagolf" target="_blank" rel="noopener noreferrer">
          <Icon icon="Instagram" />
        </a>
        <a href="https://www.youtube.com/tathatagolf" target="_blank" rel="noopener noreferrer">
          <Icon icon="YouTube" />
        </a> */}
      </div>
    );
  };

  renderHero = (chapterIndex, chapterComplete, courseComplete) => {
    const { course, chapter, lesson } = this.props;

    if (courseComplete) {
      return (
        <div className="lesson-complete__header-wrapper">
          <div className="container">
            <div className="lesson-complete__header">
              <div className="lesson-complete__header__badge">
                {course.badge_id ? (
                  <img src={course.badge.image.location} alt={course.badge.image.name} />
                ) : (
                  <Icon icon="CheckmarkCircle" />
                )}
              </div>
              <div>
                <h1>You've Completed This Course!</h1>
                <p>
                  Congratulations, you've completed {course.name}.{' '}
                  {course.badge_id ? "You've unlocked the course completion badge. View it in your profile now!" : null}
                </p>
                <h2>Share your progress</h2>
                {this.renderSocialLinks()}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (chapterComplete) {
      return (
        <div className="lesson-complete__header-wrapper">
          <div className="container">
            <div className="lesson-complete__header">
              <div className="lesson-complete__header__badge">
                {chapter.badge_id ? (
                  <img src={chapter.badge.image.location} alt={chapter.badge.image.name} />
                ) : (
                  <Icon icon="CheckmarkCircle" />
                )}
              </div>
              <div>
                <h1>You've Completed This Chapter!</h1>
                <p>
                  Congratulations, you've completed Chapter {chapterIndex + 1} of {course.name}.{' '}
                  {chapter.badge_id ? (
                    "You've unlocked the chapter completion badge. View it in your profile now!"
                  ) : null}
                </p>
                <h2>Share your progress</h2>
                {this.renderSocialLinks()}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="lesson-complete__header-wrapper">
          <div className="container">
            <div className="lesson-complete__header">
              <div className="lesson-complete__header__badge">
                <Icon icon="CheckmarkCircle" />
              </div>
              <div>
                <h1>You've Completed This Lesson!</h1>
                <p>
                  Congratulations, you've completed {lesson.name} of {course.name}. Keep up the good work!
                </p>
                <h2>Share your progress</h2>
                {this.renderSocialLinks()}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  renderAction = (lessonIndex, chapterIndex, chapterComplete, courseComplete) => {
    const { course, courses, lessons } = this.props;

    if (courseComplete) {
      const unenrolledCourses = courses.filter(c => !c.enrolled && c.id !== course.id);
      const randomCourse = unenrolledCourses.length
        ? unenrolledCourses[Math.floor(Math.random() * unenrolledCourses.length)]
        : null;
      return (
        <div className="container">
          {randomCourse ? (
            <div className="lesson-complete__footer">
              <div className="lesson-complete__footer__badge">
                {randomCourse.badge_id ? (
                  <img src={randomCourse.badge.image.location} alt={randomCourse.badge.image.name} />
                ) : (
                  <Icon icon="GraduationCap" />
                )}
              </div>
              <div>
                <h1>Keep Up Your Training</h1>
                <p>
                  If you enjoyed {course.name}, you may be interested in{' '}
                  <Link to={`/subscription/courses/${randomCourse.id}`}>{randomCourse.name}</Link>
                </p>
                <Link className="button" to={`/subscription/courses/${randomCourse.id}`}>
                  Learn More
                </Link>
              </div>
            </div>
          ) : null}
        </div>
      );
    } else if (chapterComplete) {
      return (
        <div className="container">
          <div className="lesson-complete__footer">
            <div className="lesson-complete__footer__badge">
              {course.badge_id ? (
                <img src={course.badge.image.location} alt={course.badge.image.name} />
              ) : (
                <Icon icon="GraduationCap" />
              )}
            </div>
            <div>
              <h1>Continue Learning</h1>
              <p>Start the next chapter now if you'd like!</p>
              <button className="button button--icon" onClick={this.handleNextChapter}>
                <Icon icon="PlayCircle" />Start Chapter {chapterIndex + 2}
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      const chapterId = course.chapters[chapterIndex].id;
      const nextLessonId = lessons[lessonIndex + 1].id;
      return (
        <div className="container">
          <div className="lesson-complete__footer">
            <div className="lesson-complete__footer__badge">
              {course.badge_id ? (
                <img src={course.badge.image.location} alt={course.badge.image.name} />
              ) : (
                <Icon icon="GraduationCap" />
              )}
            </div>
            <div>
              <h1>Continue Learning</h1>
              <p>Start the next lesson now if you'd like!</p>
              <Link
                className="button button--icon"
                to={`/subscription/courses/${course.id}/chapters/${chapterId}/lessons/${nextLessonId}`}
              >
                <Icon icon="PlayCircle" />Play Chapter {chapterIndex + 1}, {lessons[lessonIndex + 1].name}
              </Link>
            </div>
          </div>
        </div>
      );
    }
  };

  renderDailyExtra = () => {
    const { lesson } = this.props;

    if (lesson.daily_extra_id) {
      return <DailyExtra dailyExtra={lesson.dailyExtra} />;
    }
  };

  render() {
    const { course, lessons, lesson, chapter } = this.props;

    if (!lesson) {
      return <Redirect to={`/subscription/courses`} />;
    }

    const chapterIndex = course.chapters.findIndex(c => c.id === chapter.id);
    const lessonIndex = lessons.findIndex(l => l.id === lesson.id);
    const chapterComplete = lessons.length === lessonIndex + 1;
    const courseComplete = chapterComplete && course.chapters.length === chapterIndex + 1;

    const titleString = `${course.name} - Chapter ${course.chapters.findIndex(item => item.id === chapter.id) +
      1} - ${lesson.name}`;

    return (
      <div className="lesson-complete--wrapper">
        <Helmet>
          <title>{titleString}</title>
        </Helmet>
        {this.renderHero(chapterIndex, chapterComplete, courseComplete)}
        {this.renderAction(lessonIndex, chapterIndex, chapterComplete, courseComplete)}
        <div className="lesson-complete__daily-extra">{this.renderDailyExtra()}</div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  lessons: selectChapterLessons(state, props),
  lesson: selectLesson(state, props),
  chapter: selectChapter(state, props),
  course: selectCourse(state, props),
  courses: selectCourses(state),
});

export default withRouter(connect(mapStateToProps)(LessonComplete));



// WEBPACK FOOTER //
// ./src/subscription/courses/views/LessonComplete.js